import fileapiUploader from "./fileapiUploader"
import $ from "jquery"

export const uploadImg = (params) => {
  var url = "/ags/registration/upload",
    param = $.extend(
      true,
      {
        width: 0,
        height: 0,
      },
      params
    )
  param["url"] = url
  return fileapiUploader(param)
}

export default {
  uploadImg,
}
